<template>
  <b-form @submit.prevent="submitForm">
    <div v-if="isLoading" class="py-3 text-center text-secondary">
      {{ $t("loadingData") }}
    </div>

    <template v-else-if="selectedSubscriptionPlan">
      <b-form-group>
      <template v-slot:label>
        {{ $t("numberOfConcurrentMeetings") }}
      </template>
      <b-form-input v-model="numberOfConcurrentMeetings" type="number" min="0" required />
    </b-form-group>
      <div class="border-bottom pb-3 mb-3">
        <b-form-row>
          <b-col cols="6"><label>{{ $t("subscriptionInfo") }}</label></b-col>
          <b-col cols="6"><b>{{ selectedSubscriptionPlan.name }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("subscriptionLength") }}</b-col>
          <b-col cols="6"><b>{{ selectedSubscriptionPlan.numberOfDaysUsage }} {{ selectedSubscriptionPlan.unitTimeVN }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("maximumNumberOfParticipantsInMeeting") }}</b-col>
          <b-col cols="6"><b>{{ selectedSubscriptionPlan.maximumNumberOfParticipantsInMeeting }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("numberOfConcurrentMeetings") }}</b-col>
          <b-col cols="6"><b>{{ selectedSubscriptionPlan.numberOfConcurrentMeetings }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("maximumLengthOfOneMeeting") }}</b-col>
          <b-col cols="6"><b>{{ selectedSubscriptionPlan.maximumLengthOfOneMeeting }} {{ $t("minutes") }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("numberOfMeetingsPerMonth") }}</b-col>
          <b-col cols="6"><b>{{ selectedSubscriptionPlan.numberOfMeetingsPerMonth }}</b></b-col>
        </b-form-row>
<!--        <b-form-row>
          <b-col cols="6">Nền tảng sử dụng</b-col>
          <b-col cols="6"><b>{{ selectedSubscriptionPlan.coreImplName }}</b></b-col>
        </b-form-row>-->
      </div>

      <div class="mb-3">
        <label>{{ $t("serviceInfo") }}</label>
        <b-form-row>
          <b-col cols="6">{{ $t("currentExpDate") }}</b-col>
          <b-col cols="6"><b>{{ currentExpDateStr }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("expDateAfterRenew") }}</b-col>
          <b-col cols="6"><b>{{ expDateStr }}</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("servicePrice") }}</b-col>
          <b-col cols="6"><b>{{ priceStr }} VND</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("vatTax") }}</b-col>
          <b-col cols="6"><b>{{ taxAmountStr }} VND</b></b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="6">{{ $t("amountCustomerToPay") }}</b-col>
          <b-col cols="6"><b>{{ dueAmountStr }} VND</b></b-col>
        </b-form-row>
      </div>

      <p class="text-secondary">{{ $t("renewConfirmCorrectInfo") }}</p>

      <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

      <div class="text-right mt-4">
        <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("renewService") }}</b-button>
      </div>
    </template>

  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import _ from "lodash";
import moment, { Moment, MomentInput } from "moment";
import BaseComponent from "@/components/BaseComponent";
import * as areaService from "@/service/areaService";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import * as customerService from "@/service/customerService";
import BigNumber from "bignumber.js";


@Component
export default class ExtendSubscriptionModal extends BaseComponent {

  datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

  @Prop({ required: true }) customerSubscription;

  isLoading = true;

  subscriptionPlans = [];
  subscriptionPlanId: number = null;
  startTime: string = null;

  formErrorMsg = "";
  isSubmitting = false;
  numberOfConcurrentMeetings = 0;

  // Emit decorators only
  @Emit("submitted") __submitted() {}


  mounted() {
    this.startTime = moment().format("YYYY-MM-DD");
    this.fetchSubscriptionPlans();
  }

  async fetchSubscriptionPlans() {
    try {
      this.isLoading = true;
      this.subscriptionPlans = await subscriptionPlanService.getPlans();
      this.numberOfConcurrentMeetings = this.subscriptionPlans.find(it => it.id === this.customerSubscription?.subscriptionPlanId).numberOfConcurrentMeetings;
    } catch (e) {
      this.toastError(e);

    } finally {
      this.isLoading = false;
    }
  }

  get subscriptionPlanOptions() {
    const options: any[] = this.subscriptionPlans.map(it => ({
      value: it.id,
      text: it.name + " - " + this.formatCurrencyAmount(it.price) + " VND",
    }));
    options.unshift({ text: this.$t("chooseSubscription").toString(), value: null, disabled: true });
    return options;
  }

  get selectedSubscriptionPlan() {
    return this.subscriptionPlans.find(it => it.id === this.customerSubscription?.subscriptionPlanId);
  }

  get startTimeMoment(): Moment {
    return moment.utc(this.startTime, "YYYY-MM-DD", true);
  }

  get currentExpDateStr(): string {
    return moment(this.customerSubscription.endTime).format("DD/MM/YYYY");
  }

  get expDateStr(): string {
    let newStartTimeMoment = moment(this.customerSubscription.endTime);
    if (newStartTimeMoment.isBefore()) {
      newStartTimeMoment = moment();
    }
    return newStartTimeMoment
      .add(this.selectedSubscriptionPlan.numberOfDaysUsage, this.selectedSubscriptionPlan.unitTime)
      .format("DD/MM/YYYY");
  }

  // Hiển thị giá tiền chưa thuế
  get priceStr(): string {
    return this.formatCurrencyAmount(this.selectedSubscriptionPlan.price);
  }

  // Hiển thị thuế VAT
  get taxAmountStr(): string {
    return this.formatCurrencyAmount(
      new BigNumber(this.selectedSubscriptionPlan.price)
        .multipliedBy(0.1)
        .decimalPlaces(0)
        .toNumber()
    );
  }

  // Hiển thị giá tiền đã bao gồm thuế
  get dueAmountStr(): string {
    return this.formatCurrencyAmount(
      new BigNumber(this.selectedSubscriptionPlan.price)
        .multipliedBy(1.1)
        .decimalPlaces(0)
        .toNumber()
    );
  }


  onClickCancel() {
    this.$bvModal.hide("extend-subscription-modal");
  }


  async submitForm() {
    try {
      this.isSubmitting = true;

      await customerService.renewSubscription(this.customerSubscription.id, +this.numberOfConcurrentMeetings);
      this.__submitted();
      this.$bvModal.hide("extend-subscription-modal");
      this.toastSuccessDelay(this.$t("renewServiceSuccess").toString());

    } catch (e) {
      this.toastError(e);

    } finally {
      this.isSubmitting = false;
    }
  }

}
</script>
